import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import './StartSubmission.css';
import axios from 'axios';
import { toggleEnvironment } from '../../../../utils/apiClient';
import { api, getAuthHeaders } from '../../../../utils/api';

const StartSubmission = () => {
  const navigate = useNavigate();
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role === 'teacher') {
      navigate('/dashboard');
      return;
    }
    fetchClasses();
  }, [navigate]);

  const fetchClasses = async () => {
    try {
      setLoading(true);
      const userData = localStorage.getItem('user');
      const user = userData ? JSON.parse(userData) : null;
      const userId = user?.userId;
      
      if (!userId) {
        setError("User data not found. Please login again.");
        setLoading(false);
        return;
      }
      
      const response = await axios.get(
        `/api/v1/stem@home/student/${userId}/enrolled-classes`,
        {
          baseURL: toggleEnvironment(),
          headers: getAuthHeaders()
        }
      );
      
      console.log('Classes response:', response.data);
      
      if (response.data && response.data.success && Array.isArray(response.data.data)) {
        setClasses(response.data.data);
        setError('');
      } else {
        setError("No classes found");
        setClasses([]);
      }
    } catch (error) {
      console.error("Error fetching classes:", error);
      setError("Failed to load your classes. Please try again.");
      setClasses([]);
    } finally {
      setLoading(false);
    }
  };

  const handleClassSelect = (selectedClass) => {
    console.log('Selected class:', selectedClass);
    
    // Store class information in localStorage for persistence
    const classesInStorage = JSON.parse(localStorage.getItem('classes') || '[]');
    const updatedClasses = [...classesInStorage];
    
    // Check if class already exists in storage
    const existingClassIndex = updatedClasses.findIndex(c => c._id === selectedClass._id);
    if (existingClassIndex >= 0) {
      updatedClasses[existingClassIndex] = selectedClass;
    } else {
      updatedClasses.push(selectedClass);
    }
    
    localStorage.setItem('classes', JSON.stringify(updatedClasses));
    
    // Navigate to the question view with class details
    navigate(`/start-submission/${selectedClass._id}`, {
      state: { 
        className: selectedClass.name,
        teacherName: selectedClass.teacher?.name || 'Not assigned'
      }
    });
  };

  if (loading) {
    return (
      <div className="center-form">
        <div className="loading-message">Loading classes...</div>
      </div>
    );
  }

  return (
    <div className="center-form">
      <h1>Start Submission</h1>
      
      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

      <div className="class-selection">
        <h2>Select Your Class</h2>
        <div className="class-grid">
          {classes.length > 0 ? (
            classes.map(cls => (
              <div
                key={cls._id}
                className="class-box"
                onClick={() => handleClassSelect(cls)}
              >
                <h3>{cls.name}</h3>
              </div>
            ))
          ) : (
            <div className="no-classes">
              No classes available
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StartSubmission;